import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';
import {
  ApiService
} from '../api.service';
import {
  ActivatedRoute
} from '@angular/router';
import {
  Router,
  RouterModule
} from '@angular/router';
import {
  GlobalServices
} from '../global.services';
import {
  Location
} from '@angular/common';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  paymentcard: FormGroup;
  public isSubmiited: boolean = false;
  mode = 'determinate';
  public responseMessage: string = "";
  public showAlert: boolean = false;
  public issave: boolean = true;
  public errorMessage: string = '';
  public payData: object = {};
  public year = ['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030'];
  public month = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  public countryList: any = [];
  constructor(public fb: FormBuilder, public location: Location, public apiService: ApiService, public route: ActivatedRoute, public router: Router, public globalServices: GlobalServices) {
    
    if (this.globalServices.isBrowser) {
      if (!this.globalServices.isLoggedIn) {
        window.location.href = '/';
      }
    }

    this.paymentcard = this.fb.group({
      holdername: [null, Validators.required],
      // address: [null, Validators.required],
      // zipcode: [null, [Validators.required, Validators.pattern("^[0-9]*$")]],
      // country: [null, Validators.required],
      // city: [null, Validators.required],
      // state: [null, Validators.required],
      cardno: [null, [Validators.required, Validators.minLength(12), Validators.maxLength(20), Validators.pattern("^[0-9]*$")]],
      // expiryMonth: [null, Validators.required],
      expiryYear: [null, Validators.required],
      zipcode: [null, [Validators.pattern("^[0-9]*$")]],
      cvv: [null, [Validators.required, Validators.maxLength(3), Validators.minLength(3), Validators.pattern("^[0-9]*$")]],
    })
  }

  public isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    return !(charCode > 31 && (charCode > 48 || charCode < 57));
  }

  public chekNumber(evt) {
    if (evt.which < 48 || evt.which > 57) {
      evt.preventDefault();
    }
  }

  public subscriberdata = [];
  get f() {
    return this.paymentcard.controls
  }

  public totalPrice: number = 0;
  public GettotalPrice(){
  if(this.globalServices.isBrowser){
    this.totalPrice=0;
    for (let obj of this.subscriberdata){
      this.totalPrice += (obj['Originalprice'] != null && obj['Originalprice'] != undefined) ? +(obj['Originalprice'].toFixed(2)) : 0;
    }
  }
  }

  public DiscountPrice:number=0;
  public findDiscountPrice(){
    if(this.globalServices.isBrowser){
      this.DiscountPrice=0;
      let discountPrice=0;
      for (let obj of this.subscriberdata){
        discountPrice = discountPrice + ((obj['discount'] != null && obj['discount'] != undefined) ? +(obj['discount'].toFixed(2)) : 0);
      }
      if(discountPrice==0){
        this.DiscountPrice = this.globalTotalPrice;
      }else{
        this.DiscountPrice=discountPrice;
      }
    }
    }
    public globalTotalPrice:any;
  public coupanData:Array<object>=[];
  public appliedCode:string='';
  public originalData:Array<any>=[];
  ngOnInit(): void {
    if (this.globalServices.isBrowser) 
    this.globalServices?.hideHeader.next(false);
    this.globalServices?.hideFooter.next(false);
      window.scrollTo(0, 0);
      if(this.globalServices.direcPaymentPage){
        let urls = 'billingservice/subscription/detail/all';
        let data = {
          'slug': 'global'
        };
        this.apiService.postbillData(urls, data).subscribe((res) => {
          if (res && res['data'] && res['data']) {
            let response: any = res['data'];
            let  selected_Plan = response.filter(function (e) {
              return e.subscriptionType === 'monthly';
            });
            console.log(selected_Plan);
            let data  = selected_Plan[0]['subsPlans'].filter(function (e) {
              return e.slug === 'wellness-enthusiast';
            });
            console.log(data);
        let requireddata=[];
        requireddata.push({
          price: data[0]['planDurationObject']['price'] - ((data[0]['planDurationObject']['price'] / 100) * +(data[0]['shopDiscount'] ? data[0]['shopDiscount'] : 0)),
          subscriptionId: (data[0] && data[0][Object.keys(data[0])[0]] && data[0] && data[0] && data[0][Object.keys(data[0])[0]] && data[0]['_id']) || '',
          subscriptionName: (data[0] && data[0][Object.keys(data[0])[0]] && data[0] && data[0] && data[0][Object.keys(data[0])[0]] && data[0]['name']) || '',
          subscriptionType: (data[0] && data[0][Object.keys(data[0])[0]] && data[0] && data[0]['subscriptionType']) || '',
          planCategoryId: data[0] && data[0][Object.keys(data[0])[0]] && data[0]['planCategoryId'] ? data[0] && data[0][Object.keys(data[0])[0]] && data[0]['planCategoryId'] : '',
          activeTriCamp: data[0] && data[0][Object.keys(data[0])[0]] && data[0]['activeTriCamp'],
          triCapmDurStart: data[0] && data[0][Object.keys(data[0])[0]] && data[0]['triCapmDurStart'],
          triCapmDurEnd: data[0] && data[0][Object.keys(data[0])[0]] && data[0]['triCapmDurEnd'],
          isTrial: data[0] && data[0][Object.keys(data[0])[0]] && data[0]['isTrial'],
          noOfDay: data[0] && data[0][Object.keys(data[0])[0]] && data[0]['noOfDay'],
          plandur: data[0] && data[0][Object.keys(data[0])[0]] && data[0]['plandur'] ? data[0] && data[0][Object.keys(data[0])[0]] && data[0]['plandur'] : 1,
          durtype: 'month',
          isTrialUsed: (data[0] && data[0][Object.keys(data[0])[0]] && data[0] && data[0][Object.keys(data[0])[0]] && data[0]['isTrialUsed'] == undefined || data[0] && data[0][Object.keys(data[0])[0]] && data[0]['isTrialUsed'] == null) ? 0 : data[0] && data[0][Object.keys(data[0])[0]] && data[0]['isTrialUsed'],
          occurtype: data[0] && data[0][Object.keys(data[0])[0]] && data[0]['occurtype'] ? data[0] && data[0][Object.keys(data[0])[0]] && data[0]['occurtype'] : '',
          planUsename: 'monthly',
        });
      console.log(requireddata);
      localStorage.setItem('planpayment',JSON.stringify(requireddata));
      this.getdeatils()
    }
    });
      }else{
   this.getdeatils();
      }
      // this.paymentcard.patchValue({
      //   'expiryMonth': this.month[0],
      //   'expiryYear': this.year[0]
      // });
  }
  public getdeatils(){
    let coupanprice = [];
    this.subscriberdata = [];
    this.originalData = JSON.parse(localStorage.getItem('planpayment'));
    console.log('this.originalData',this.originalData);
    let planData = JSON.parse(localStorage.getItem('planpayment'));
    console.log('plan',planData);
  if(planData){
    console.log('plan',planData);
  let data = planData.filter(function (e) {
    return e.subscriptionId !== '';
  });
  for(let i=0;i<data.length;i++){
  coupanprice.push({
        originalAmount:data[i]['price'],
        subscriptionCategoryId:data[i]['planCategoryId'],
        subscriptionId:data[i]['subscriptionId'],
        isTrial:data[i]['isTrial'],
        isTrialUsed:data[i]['isTrialUsed'],
        subscriptionName:data[i]['subscriptionName'].trim(),
        subscriptionCategoryName:(data[i]['planUsename']=='plan')?'general':data[i]['planUsename'],
        });
  }
}
  let url= 'billingservice/coupon/api/get';
  this.globalTotalPrice=0;
  this.apiService.postbillData(url,coupanprice).subscribe((response)=>{
    if(response){
    this.coupanData = response;
    this.appliedCode = response['appliedCoupon'];
    this.globalTotalPrice = response['globalDiscount']['discount'];
    this.expireTrialDate = response['noOfDays']?.length>0?new Date(response['noOfDays'][0]['expiryDate']).toLocaleString().split(',')[0]:'';
    this.backup_date_trial = this.expireTrialDate;
    // console.log('ddddddddddddddddd',this.expireTrialDate);
    for(let couponObj of this.coupanData['categoryDiscount']){
      for(let [i,subObj] of planData.entries()){
            if(couponObj['subscriptionCategoryId'] == subObj['planCategoryId']){
              planData[i]['Originalprice']= +(couponObj['originalAmount']);
            planData[i]['priceAfterCoupon']= +(couponObj['discountedAmount']);
              planData[i]['discount']= +(couponObj['discount']);
              break;
            }
      }
    }
    this.subscriberdata = planData;
   for(let i=0;i>this.subscriberdata.length;i++){
     this.showdays= this.subscriberdata[i]['isTrial'] && !this.subscriberdata[i]['isTrialUsed'];
     if(this.showdays) break;
   }
    this.GettotalPrice();
    this.findDiscountPrice();
  localStorage.setItem('planpayment', JSON.stringify(this.subscriberdata));
  }else{
    this.subscriberdata = JSON.parse(localStorage.getItem('planpayment'));
    this.GettotalPrice();
  }
  },(err)=>{
    this.subscriberdata = JSON.parse(localStorage.getItem('planpayment'));
    this.GettotalPrice();
  });
  }
  public showdays:boolean=false;
  public backup_date_trial:any;
public status:string='';
public keyCheck(e){
  if (e.keyCode == 13) {
      e.preventDefault();
      return false;
  }
}




public orderoldPlan:string='';
public originalPrice=[];

applyCode(){
  if(this.appliedCode!=''){
  if((this.orderoldPlan!=this.appliedCode) || this.deleFlag){
      this.orderoldPlan=this.appliedCode;
      this.deleFlag = false;
      
       let planData = JSON.parse(localStorage.getItem('planpayment'));
       let data = planData.filter(function (e) {
        return e.subscriptionId !== '';
    });
    
let coupanprice=[];
for(let i=0;i<data.length;i++){
coupanprice.push({
      originalAmount:data[i]['price'],
      subscriptionCategoryId:data[i]['planCategoryId'],
      subscriptionId:data[i]['subscriptionId'],
      isTrial:data[i]['isTrial'],
      isTrialUsed:data[i]['isTrialUsed'],
      subscriptionName:data[i]['subscriptionName'].trim(),
      subscriptionCategoryName:(data[i]['planUsename']=='plan')?'general':data[i]['planUsename'],
      });
};
if(this.orderoldPlan=='MEDIA90'){
  this.status='Your promo code for "90 Days Free Trial" has been applied successfully in your account';
  setTimeout(() => {
    this.status='';
  },3000);
  this.expireTrialDate = new Date(1615375978832)?.toLocaleString()?.split(',')[0];
  return false;
}
let obj =
  {
    "couponCode":this.appliedCode,
    "reqData":coupanprice
 };
let url= 'billingservice/coupon/api/apply';
this.apiService.postbillData(url,obj).subscribe((response)=>{
  if(response){
    this.status = response['status'];
    this.removeCode('str');
    this.coupanData = response;
    this.appliedCode = response['appliedCoupon'];
    this.globalTotalPrice = response['globalDiscount']['discount'];
    if(this.coupanData['categoryDiscount'].length==0){
      this.orderoldPlan='';
    }
    for(let couponObj of this.coupanData['categoryDiscount']){
      for(let [i,subObj] of planData.entries()){
            if(couponObj['subscriptionCategoryId'] == subObj['planCategoryId']){
              planData[i]['Originalprice']= +(couponObj['originalAmount']);
              planData[i]['priceAfterCoupon']= +(couponObj['discountedAmount']);
              planData[i]['discount']= +(couponObj['discount']);
              break;
            }
      }
    }
    this.subscriberdata = planData;
    this.GettotalPrice();
    this.findDiscountPrice();
    setTimeout(() => {
      this.status='';
    },3000);
  }
},(err)=>{
  this.subscriberdata = JSON.parse(localStorage.getItem('planpayment'));
  this.GettotalPrice();
});
    } else {
      this.status='This coupon is already applied';
      setTimeout(() => {
        this.status='';
      },3000);  
    }
  }else{
    this.subscriberdata = JSON.parse(localStorage.getItem('planpayment'));
    this.GettotalPrice();
  }
  }
  
  getRound(val:any){
    return Math.round(( val+ Number.EPSILON) * 100) / 100;
  }
  removeCode(val){
    if(val=='str'){
      this.appliedCode = '';
      this.DiscountPrice=0;
        this.GettotalPrice();
    }else{
    this.orderoldPlan = '';
    this.appliedCode = '';
    this.DiscountPrice=0;
    this.expireTrialDate = this.backup_date_trial;
      this.GettotalPrice();
    }
  }
  public expireTrialDate:any='';
  ngAfterViewInit(): void {
    // if(this.globalServices.isBrowser){

      
// add a day
  //  var d = new Date();
  //   console.log(d.toLocaleDateString());
  //   d.setMonth(d.getMonth() + 1);
  //   d.setDate(d.getDate() - 1);
  //   this.expireTrialDate= d.toLocaleDateString();
  //   let url = 'global/country';
  //   this.apiService.getData(url).subscribe((res) => {
  //     if (res && res['countryRecord']) {
  //       this.countryList = res['countryRecord'];
  //       this.paymentcard.get('country').setValue(this.countryList[0]['name']);
  //     }
  //   })
  // }
  }
public deleFlag:boolean=false;
  delData(obj, i) {
    if(this.globalServices.isBrowser){
    let data: any = JSON.parse(localStorage.getItem('dataArray'));
    let plan:any = JSON.parse(localStorage.getItem('planpayment'));
    data.splice(i, 1);
    this.subscriberdata.splice(i, 1);
    plan.splice(i,1);
    this.totalPrice=0;
    this.DiscountPrice=0;
    data = data.slice();
    // this.subscriberdata = this.subscriberdata.slice();
    localStorage.setItem('planpayment', JSON.stringify(plan));
    localStorage.setItem('dataArray', JSON.stringify(data));
    setTimeout(() => {
      this.deleFlag=true;
    this.applyCode();
    }, 200);
  }
  }

  public pad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

  public submitPaymentDetails() {    
    if (this.globalServices.isBrowser) {
      this.isSubmiited = true;
      if (this.paymentcard.invalid || this.paymentcard['controls']['expiryYear']['value']?.trim().split('/')[0].length==0 || this.paymentcard['controls']['expiryYear']['value']?.trim().split('/')[1].length==0 ) {
        this.paymentcard.controls['expiryYear'].setValue('');
        return;
      }
      this.subscriberdata = this.subscriberdata.filter(function (e) {
        return ((e['price'] !== null) && (e['price'] !== '') && (e['price'] !== undefined))
      });
  
      for (let i = 0; i < this.subscriberdata.length; i++) {
        for (let j = 0; j < Object.keys(this.subscriberdata[i]).length; j++) {
          if ((Object.keys(this.subscriberdata[i])[j] == 'planUsename') || (Object.keys(this.subscriberdata[i])[j] == 'Originalprice') || (Object.keys(this.subscriberdata[i])[j] == 'discount') ) {
            if(this.subscriberdata[i]['planUsename'])
            delete this.subscriberdata[i]['planUsename'];
            if(this.subscriberdata[i]['Originalprice'])
            delete this.subscriberdata[i]['Originalprice'];
            if(this.subscriberdata[i]['discount'])
            delete this.subscriberdata[i]['discount'];
          }
        }
      }
      let userToken = localStorage.getItem('userToken');
      if (userToken && this.subscriberdata) {
        let data = {
          cardDetails: {
            isSignup:0,
            cardNumber: this.paymentcard['controls']['cardno']['value'] || '',
            month: this.paymentcard['controls']['expiryYear']['value'].split('/')[0] || '',
            year: (this.paymentcard['controls']['expiryYear']['value'].split('/')[1].length>2?(this.paymentcard['controls']['expiryYear']['value'].split('/')[1]).substr(2, 2):this.paymentcard['controls']['expiryYear']['value'].split('/')[1]) || '',
            cvv: this.paymentcard['controls']['cvv']['value'] || '',
            cardHolderName: this.paymentcard['controls']['holdername']['value'] || '',
            zipcode: this.paymentcard['controls']['zipcode']['value'] || '',
            // address: this.paymentcard['controls']['address']['value'] || '',
            // country: this.paymentcard['controls']['country']['value'] || '',
            // city: this.paymentcard['controls']['city']['value'] || '',
            // state: this.paymentcard['controls']['state']['value'] || '',
            vid:'',
            firstName:'',
            lastName:'',
            email:'',
            timezone:'',
            isSaveCard: this.issave ? 1 : 0,
            couponCode:this.appliedCode,
            discountAmount:this.DiscountPrice,
            totalPayPrice:(this.totalPrice-this.DiscountPrice)
          },
          productDetails: this.subscriberdata,
          token: userToken || '',
        };
        this.mode = 'indeterminate';
        let url = 'billingservice/usersubscription/payment';
        this.apiService.postbillData(url, data).subscribe((response) => {
          this.mode = 'determinate';
          this.payData = response;
          if (response.status === true) {
            if(response && response.paymentDeducted){
            this.showAlert = true;
            this.responseMessage = 'Payment Successfull!';
            }
            localStorage.removeItem('planpayment');
            localStorage.removeItem('dataArray');
            setTimeout(() => {
              localStorage.removeItem('bookingpage');
              localStorage.setItem('planUserId', JSON.stringify({
                userId: this.payData['userId']
              }));
              this.router.navigate(['/confirmation']);
            }, 3000);
          } else {
            this.subscriberdata = JSON.parse(localStorage.getItem('planpayment'));
      this.GettotalPrice();
      this.findDiscountPrice();
            // this.subscriberdata = planFinalData;
            this.showAlert = true;
            // let message = JSON.parse(response['message'])['message']?JSON.parse(response['message'])['message']:'error.error';
            // message = message.split('.');
            // this.responseMessage=message[1]?message[1]:'';
            this.responseMessage = "Sorry, we could not complete the transaction. Please try again later!";
            // this.responseMessage = 'Please check credit card information for accuracy OR Your Credit Card has been Declined, please provide an alternate card or check with your bank';
          }
        }, (err) => {
          // this.subscriberdata = planFinalData;
          this.errorMessage = 'Something went wrong!';
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        });
      } else {
        this.showAlert = true;
        this.responseMessage = 'Something Went Wrong!';
      }
    }
  }
  public triggerCloseEvent() {
    this.showAlert = false;
  }

  getfinalprice(final) {
    if (this.globalServices.isBrowser) {
      return (final);
    }
  }
  
  updateKey(event){
    if(event.target.value){
      if(event.target.value.trim().toString().length==2){
        if(!event.target.value.trim().toString().includes('/'))
        this.paymentcard.controls['expiryYear'].setValue(this.paymentcard.controls['expiryYear'].value+'/');
      }
    }
  }
}
